export var GiftPurchaseType = /*#__PURE__*/ function(GiftPurchaseType) {
    GiftPurchaseType[GiftPurchaseType["GiftURL"] = 0] = "GiftURL";
    GiftPurchaseType[GiftPurchaseType["GiftToUser"] = 1] = "GiftToUser";
    return GiftPurchaseType;
}({});
